import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Injectable, Pipe, PipeTransform, SecurityContext } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) {}

    transform(value: string, isUnstrictMode?: boolean): string | SafeHtml {
        if (!isUnstrictMode) {
            return this.sanitized.sanitize(SecurityContext.HTML, value || '');
        } else {
            return this.sanitized.bypassSecurityTrustHtml(value || '');
        }
    }
}
